import { UsersPageTranslations } from "./types";

export const deTranslations: UsersPageTranslations = {
    title: "Benutzer",
    columns: {
        firstName: "Vorname",
        lastName: "Nachname",
        email: "E-Mail",
        role: "Rolle",
        licenseKey: "Lizenzschlüssel",
        actions: "Aktionen",
    },
    buttons: {
        changeRole: "Rolle ändern",
        resetPassword: "Passwort zurücksetzen",
        removeLicenseKey: "Lizenzschlüssel entfernen",
        addNewLicenseKey: "Lizenzschlüssel hinzufügen",
    },
    noRecordText: "Noch keine Benutzer",
    loadingText: "Benutzer werden geladen…",
    copyConfirmation: "Kopiert!",
    search: {
        placeholder: "Nach E-Mail, Rolle oder Lizenzschlüssel suchen",
        noMatches: "Keine Benutzer entsprechen Ihrer Suche",
    },
    pagination: {
        previous: "Zurück",
        next: "Weiter",
    },
};
